import React, { useState, useEffect } from "react";
import {
  FaLaptopCode,
  FaGlobe,
  FaHandshake,
  FaCreditCard,
  FaCopyright,
  FaExclamationTriangle,
  FaBalanceScale,
  FaShieldAlt,
  FaUserSecret,
  FaBan,
  FaPlug,
  FaGavel,
  FaHistory,
  FaEnvelope,
  FaRegCheckCircle,
  FaArrowRight
} from "react-icons/fa";
import Header from "../Home/Header";
import Footer from "../Home/Footer";
// Reuse the exact same premium CSS classes from the Privacy Policy page
import "../PrivacyPolicy/PrivacyPolicy.css";

const sections = [
  { id: "services", title: "1. Services Overview", icon: <FaLaptopCode />, iconClass: "icon-blue" },
  { id: "website", title: "2. Use of Website", icon: <FaGlobe />, iconClass: "icon-purple" },
  { id: "engagement", title: "3. Project Engagement", icon: <FaHandshake />, iconClass: "icon-indigo" },
  { id: "payments", title: "4. Payments & Refunds", icon: <FaCreditCard />, iconClass: "icon-green" },
  { id: "ip", title: "5. Intellectual Property", icon: <FaCopyright />, iconClass: "icon-blue" },
  { id: "blockchain", title: "6. Blockchain & Crypto Disclaimer", icon: <FaExclamationTriangle />, iconClass: "icon-yellow" },
  { id: "compliance", title: "7. Compliance Responsibility", icon: <FaBalanceScale />, iconClass: "icon-purple" },
  { id: "liability", title: "8. Limitation of Liability", icon: <FaShieldAlt />, iconClass: "icon-gray" },
  { id: "confidentiality", title: "9. Confidentiality", icon: <FaUserSecret />, iconClass: "icon-indigo" },
  { id: "termination", title: "10. Termination", icon: <FaBan />, iconClass: "icon-gray" },
  { id: "thirdparty", title: "11. Third-Party Services", icon: <FaPlug />, iconClass: "icon-blue" },
  { id: "governing", title: "12. Governing Law", icon: <FaGavel />, iconClass: "icon-purple" },
  { id: "updates", title: "13. Updates to Terms", icon: <FaHistory />, iconClass: "icon-green" },
  { id: "contact", title: "14. Contact Information", icon: <FaEnvelope />, iconClass: "icon-indigo" },
];

const TermsCondition = () => {
  const [activeSection, setActiveSection] = useState(sections[0].id);

  useEffect(() => {
    window.scrollTo(0, 0);
    
    const handleScroll = () => {
      let currentSection = sections[0].id;
      for (const section of sections) {
        const element = document.getElementById(section.id);
        if (element && window.scrollY >= element.offsetTop - 250) {
          currentSection = section.id;
        }
      }
      setActiveSection(currentSection);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 120,
        behavior: "smooth"
      });
    }
  };

  return (
    <div className="privacy-page-container">
      <Header />

      {/* Hero Section */}
      <div className="privacy-hero">
        <div className="privacy-hero-bg-orb-1" />
        <div className="privacy-hero-bg-orb-2" />

        <div className="privacy-hero-content">
          <div className="privacy-effective-date">
            Effective Date: 1st APR 2026
          </div>
          <h1 className="privacy-title">
            Terms & <span className="privacy-title-highlight">Conditions</span>
          </h1>
          <p className="privacy-subtitle">
            Welcome to Xeer Technology. By accessing our website or engaging with our services, you agree to comply with the following terms and conditions.
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="privacy-container">
        
        {/* Sticky Sidebar Navigation */}
        <div className="privacy-sidebar">
          <div className="privacy-sidebar-nav">
            <h3 className="privacy-sidebar-title">Contents</h3>
            <div className="privacy-nav-list">
              {sections.map((sec) => (
                <button
                  key={sec.id}
                  onClick={() => scrollToSection(sec.id)}
                  className={`privacy-nav-btn ${activeSection === sec.id ? "active" : ""}`}
                >
                  <span className="privacy-nav-icon">{sec.icon}</span>
                  <span>{sec.title}</span>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Content Area */}
        <div className="privacy-main-content">
          
          {/* Section 1 */}
          <section id="services" className="privacy-section-card">
            <div className="privacy-section-header">
              <div className={`privacy-icon-wrapper ${sections[0].iconClass}`}>
                {sections[0].icon}
              </div>
              <h2 className="privacy-section-title">1. Services Overview</h2>
            </div>
            <p className="privacy-text">
              Xeer Technology provides services including but not limited to:
            </p>
            <ul className="privacy-list">
              <li><FaRegCheckCircle className="privacy-list-icon" /> <span>Blockchain and Web3 development</span></li>
              <li><FaRegCheckCircle className="privacy-list-icon" /> <span>Smart contract development</span></li>
              <li><FaRegCheckCircle className="privacy-list-icon" /> <span>Crypto-related platforms and integrations</span></li>
              <li><FaRegCheckCircle className="privacy-list-icon" /> <span>Custom software development (CRM, ERP, etc.)</span></li>
            </ul>
          </section>

          {/* Section 2 */}
          <section id="website" className="privacy-section-card">
            <div className="privacy-section-header">
              <div className={`privacy-icon-wrapper ${sections[1].iconClass}`}>
                {sections[1].icon}
              </div>
              <h2 className="privacy-section-title">2. Use of Website</h2>
            </div>
            <p className="privacy-text">
              You agree:
            </p>
            <ul className="privacy-list">
              <li><FaRegCheckCircle className="privacy-list-icon" /> <span>Not to misuse the website for illegal purposes</span></li>
              <li><FaRegCheckCircle className="privacy-list-icon" /> <span>Not to attempt unauthorized access</span></li>
              <li><FaRegCheckCircle className="privacy-list-icon" /> <span>Not to disrupt or damage website functionality</span></li>
            </ul>
          </section>

          {/* Section 3 */}
          <section id="engagement" className="privacy-section-card">
            <div className="privacy-section-header">
              <div className={`privacy-icon-wrapper ${sections[2].iconClass}`}>
                {sections[2].icon}
              </div>
              <h2 className="privacy-section-title">3. Project Engagement</h2>
            </div>
            <p className="privacy-text">
              All project engagements:
            </p>
            <ul className="privacy-list">
              <li><FaRegCheckCircle className="privacy-list-icon" /> <span>Require mutual agreement on scope, timeline, and cost</span></li>
              <li><FaRegCheckCircle className="privacy-list-icon" /> <span>May include milestone-based payments</span></li>
              <li><FaRegCheckCircle className="privacy-list-icon" /> <span>Are subject to change requests and revisions</span></li>
            </ul>
          </section>

          {/* Section 4 */}
          <section id="payments" className="privacy-section-card">
            <div className="privacy-section-header">
              <div className={`privacy-icon-wrapper ${sections[3].iconClass}`}>
                {sections[3].icon}
              </div>
              <h2 className="privacy-section-title">4. Payments & Refunds</h2>
            </div>
            <ul className="privacy-list">
              <li><FaRegCheckCircle className="privacy-list-icon" /> <span>Payments must be made as per agreed terms</span></li>
              <li><FaRegCheckCircle className="privacy-list-icon" /> <span>Advance payments are non-refundable</span></li>
              <li><FaRegCheckCircle className="privacy-list-icon" /> <span>Refunds (if applicable) are subject to mutual agreement</span></li>
            </ul>
          </section>

          {/* Section 5 */}
          <section id="ip" className="privacy-section-card">
            <div className="privacy-section-header">
              <div className={`privacy-icon-wrapper ${sections[4].iconClass}`}>
                {sections[4].icon}
              </div>
              <h2 className="privacy-section-title">5. Intellectual Property</h2>
            </div>
            <ul className="privacy-list">
              <li><FaRegCheckCircle className="privacy-list-icon" /> <span>All custom development work becomes the client’s property after full payment</span></li>
              <li><FaRegCheckCircle className="privacy-list-icon" /> <span>Xeer Technology retains the right to showcase work in portfolio unless restricted</span></li>
              <li><FaRegCheckCircle className="privacy-list-icon" /> <span>Third-party tools or licenses remain subject to their respective owners</span></li>
            </ul>
          </section>

          {/* Section 6 - Blockchain Disclaimer (Warning Style) */}
          <section id="blockchain" className="privacy-disclaimer">
            <div className="privacy-disclaimer-bg" />
            <div className="privacy-disclaimer-content">
              <div className="privacy-section-header">
                <div className={`privacy-icon-wrapper ${sections[5].iconClass}`}>
                  {sections[5].icon}
                </div>
                <h2 className="privacy-section-title">6. Blockchain & Crypto Disclaimer</h2>
              </div>
              
              <ul className="privacy-list" style={{ marginTop: '0', marginBottom: '24px' }}>
                <li style={{ color: '#d1d5db' }}><FaExclamationTriangle className="text-yellow" style={{marginTop: '4px'}} /> <span>Blockchain technology involves inherent risks</span></li>
                <li style={{ color: '#d1d5db' }}><FaExclamationTriangle className="text-yellow" style={{marginTop: '4px'}} /> <span>Cryptocurrency markets are volatile</span></li>
                <li style={{ color: '#d1d5db' }}><FaExclamationTriangle className="text-yellow" style={{marginTop: '4px'}} /> <span>Smart contracts are immutable once deployed</span></li>
              </ul>

              <div className="privacy-disclaimer-box">
                <p>
                  <strong className="text-yellow">Xeer Technology:</strong>
                </p>
                <div className="privacy-grid" style={{ marginTop: '16px' }}>
                  <div className="privacy-rights-card">
                    <div className="privacy-rights-icon" style={{ backgroundColor: 'rgba(234, 179, 8, 0.1)', color: '#facc15' }}>
                      <FaBan />
                    </div>
                    <div>
                      <h4 style={{ color: '#facc15' }}>No Financial Guarantees</h4>
                      <p>Does not guarantee financial outcomes.</p>
                    </div>
                  </div>
                  <div className="privacy-rights-card">
                    <div className="privacy-rights-icon" style={{ backgroundColor: 'rgba(234, 179, 8, 0.1)', color: '#facc15' }}>
                      <FaShieldAlt />
                    </div>
                    <div>
                      <h4 style={{ color: '#facc15' }}>Not Responsible for Loss</h4>
                      <p>Is not responsible for losses due to market behavior or misuse.</p>
                    </div>
                  </div>
                  <div className="privacy-rights-card privacy-grid-full">
                    <div className="privacy-rights-icon" style={{ backgroundColor: 'rgba(234, 179, 8, 0.1)', color: '#facc15' }}>
                      <FaBalanceScale />
                    </div>
                    <div>
                      <h4 style={{ color: '#facc15' }}>No Investment Advice</h4>
                      <p>Does not provide financial or investment advice.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Section 7 */}
          <section id="compliance" className="privacy-section-card">
            <div className="privacy-section-header">
              <div className={`privacy-icon-wrapper ${sections[6].iconClass}`}>
                {sections[6].icon}
              </div>
              <h2 className="privacy-section-title">7. Compliance Responsibility</h2>
            </div>
            <p className="privacy-text">
              Clients are solely responsible for:
            </p>
            <ul className="privacy-list">
              <li><FaRegCheckCircle className="privacy-list-icon" /> <span>Regulatory compliance (local/international laws)</span></li>
              <li><FaRegCheckCircle className="privacy-list-icon" /> <span>KYC/AML requirements</span></li>
              <li><FaRegCheckCircle className="privacy-list-icon" /> <span>Licensing and legal approvals</span></li>
            </ul>
          </section>

          {/* Section 8 */}
          <section id="liability" className="privacy-section-card">
            <div className="privacy-section-header">
              <div className={`privacy-icon-wrapper ${sections[7].iconClass}`}>
                {sections[7].icon}
              </div>
              <h2 className="privacy-section-title">8. Limitation of Liability</h2>
            </div>
            <p className="privacy-text">
              Xeer Technology shall not be liable for:
            </p>
            <ul className="privacy-list">
              <li><FaBan className="privacy-list-icon text-gray-500" style={{ color: '#9ca3af' }} /> <span>Indirect or consequential damages</span></li>
              <li><FaBan className="privacy-list-icon text-gray-500" style={{ color: '#9ca3af' }} /> <span>Financial losses due to system usage</span></li>
              <li><FaBan className="privacy-list-icon text-gray-500" style={{ color: '#9ca3af' }} /> <span>Downtime caused by third-party services</span></li>
            </ul>
          </section>

          {/* Section 9 */}
          <section id="confidentiality" className="privacy-section-card">
            <div className="privacy-section-header">
              <div className={`privacy-icon-wrapper ${sections[8].iconClass}`}>
                {sections[8].icon}
              </div>
              <h2 className="privacy-section-title">9. Confidentiality</h2>
            </div>
            <p className="privacy-text">
              Both parties agree to maintain confidentiality of:
            </p>
            <div className="privacy-grid">
              <div className="privacy-subcard">
                <h4>Project Details</h4>
                <p>All sensitive information regarding project scope, architecture, and timeline.</p>
              </div>
              <div className="privacy-subcard">
                <h4>Business Data</h4>
                <p>Proprietary business strategies, client lists, and operational procedures.</p>
              </div>
              <div className="privacy-subcard privacy-grid-full">
                <h4>Technical Information</h4>
                <p>Source code drafts, server credentials, and proprietary algorithms.</p>
              </div>
            </div>
          </section>

          {/* Section 10 */}
          <section id="termination" className="privacy-section-card">
            <div className="privacy-section-header">
              <div className={`privacy-icon-wrapper ${sections[9].iconClass}`}>
                {sections[9].icon}
              </div>
              <h2 className="privacy-section-title">10. Termination</h2>
            </div>
            <p className="privacy-text">
              We reserve the right to:
            </p>
            <ul className="privacy-list">
              <li><FaRegCheckCircle className="privacy-list-icon" /> <span>Terminate services in case of breach of terms</span></li>
              <li><FaRegCheckCircle className="privacy-list-icon" /> <span>Suspend access for misuse or illegal activity</span></li>
            </ul>
          </section>

          {/* Section 11 */}
          <section id="thirdparty" className="privacy-section-card">
            <div className="privacy-section-header">
              <div className={`privacy-icon-wrapper ${sections[10].iconClass}`}>
                {sections[10].icon}
              </div>
              <h2 className="privacy-section-title">11. Third-Party Services</h2>
            </div>
            <p className="privacy-text">
              We may integrate third-party APIs or tools. We are not responsible for their performance, downtime, or policies.
            </p>
          </section>

          {/* Section 12 */}
          <section id="governing" className="privacy-section-card">
            <div className="privacy-section-header">
              <div className={`privacy-icon-wrapper ${sections[11].iconClass}`}>
                {sections[11].icon}
              </div>
              <h2 className="privacy-section-title">12. Governing Law</h2>
            </div>
            <p className="privacy-text">
              These terms shall be governed by the laws of India. Any disputes will be subject to jurisdiction of Gujarat courts.
            </p>
          </section>

          {/* Section 13 */}
          <section id="updates" className="privacy-section-card">
            <div className="privacy-section-header">
              <div className={`privacy-icon-wrapper ${sections[12].iconClass}`}>
                {sections[12].icon}
              </div>
              <h2 className="privacy-section-title">13. Updates to Terms</h2>
            </div>
            <p className="privacy-text">
              We may update these terms at any time. Continued use of services implies acceptance of updated terms.
            </p>
          </section>

          {/* Section 14 - CTA Style */}
          <section id="contact" className="privacy-cta">
            <div className="privacy-cta-pattern" />
            <div className="privacy-cta-content">
              <div className="privacy-cta-icon">
                <FaEnvelope />
              </div>
              <h2 className="privacy-cta-title">14. Contact Information</h2>
              <p className="privacy-cta-text">
                For any queries regarding these Terms & Conditions, please get in touch with Xeer Technology.
              </p>
              <div className="privacy-cta-buttons" style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <a href="mailto:Info@xeertechnology.com" className="privacy-btn-primary">
                  <span>Info@xeertechnology.com</span>
                  <FaArrowRight size={14} />
                </a>
                <a href="https://xeertechnology.com/" target="_blank" rel="noreferrer" className="privacy-btn-secondary">
                  xeertechnology.com
                </a>
              </div>
            </div>
          </section>

        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default TermsCondition;
